import { IModel } from '@/@types/models/model';
import coreFields from './helpers/coreFields';

const listFields = [
  'id',
  'oznaka_plana',
  'oznaka_revizije',
  'naziv_plana',
  'mbr_jls',
  'zupanija_naziv',
  'vrsta_plana_naziv',
  'vrsta_postupka_naziv',
  'faza_naziv',
  'status_plana_naziv',
  'status_postupka_naziv',
  'zadnja_promjena',
  'strucni_izradivac',
  'datum_objave',
  'datum_stupanja_na_snagu',
  'odgovorna_organizacija',
  'poveznica',
  'izvan_snage',
  'nova_generacija',
  'created_by',
  'created_on',
  'modified_by',
  'modified_on',
];

const RegistarProstornihPlanova: IModel = {
  title: 'Registar prostornih planova',
  apiPath: 'registar-prostornih-planova',
  forms: {
    default: {
      fields: listFields,
    },
  },
  listViews: {
    default: {
      fields: listFields,
      hidden: ['id'],
    },
  },
  fields: [
    coreFields.id,
    {
      title: 'oznaka_plana',
      source: 'oznaka_plana',
      ttoken: 'pp:registar.oznaka_plana',
      type: 'text',
      filter: true,
      readonly: true,
    },
    {
      title: 'oznaka_revizije',
      source: 'oznaka_revizije',
      ttoken: 'pp:registar.oznaka_revizije',
      type: 'text',
      filter: true,
      readonly: true,
    },
    {
      title: 'naziv_plana',
      source: 'naziv_plana',
      ttoken: 'pp:registar.naziv_plana',
      type: 'text',
      filter: true,
      readonly: true,
      width: 'full',
    },
    {
      title: 'mbr_jls',
      source: 'mbr_jls',
      ttoken: 'pp:registar.mbr_jls',
      type: 'numeric',
      filterType: 'text',
      filter: true,
      readonly: true,
    },
    {
      title: 'zupanija',
      source: 'zupanija_naziv',
      ttoken: 'pp:registar.zupanija',
      type: 'text',
      filter: true,
      readonly: true,
    },
    {
      title: 'vrsta_plana',
      source: 'vrsta_plana_naziv',
      ttoken: 'pp:registar.vrsta_plana',
      type: 'text',
      filter: true,
      readonly: true,
    },
    {
      title: 'vrsta_postupka',
      source: 'vrsta_postupka_naziv',
      ttoken: 'pp:registar.vrsta_postupka',
      type: 'text',
      filter: true,
      readonly: true,
    },
    {
      title: 'faza',
      source: 'faza_naziv',
      ttoken: 'pp:registar.faza',
      type: 'text',
      filter: true,
      readonly: true,
    },
    {
      title: 'status_plana',
      source: 'status_plana_naziv',
      ttoken: 'pp:registar.status_plana',
      type: 'text',
      filter: true,
      readonly: true,
    },
    {
      title: 'status_postupka',
      source: 'status_postupka_naziv',
      ttoken: 'pp:registar.status_postupka',
      type: 'text',
      filter: true,
      readonly: true,
    },
    {
      title: 'zadnja_promjena',
      source: 'zadnja_promjena',
      ttoken: 'pp:registar.zadnja_promjena',
      type: 'date',
      filter: true,
      readonly: true,
    },
    {
      title: 'strucni_izradivac',
      source: 'strucni_izradivac',
      ttoken: 'pp:registar.strucni_izradivac',
      type: 'text',
      filter: true,
      readonly: true,
    },
    {
      title: 'datum_objave',
      source: 'datum_objave',
      ttoken: 'pp:registar.datum_objave',
      type: 'date',
      filter: true,
      readonly: true,
    },
    {
      title: 'datum_stupanja_na_snagu',
      source: 'datum_stupanja_na_snagu',
      ttoken: 'pp:registar.datum_stupanja_na_snagu',
      type: 'date',
      filter: true,
      readonly: true,
    },
    {
      title: 'odgovorna_organizacija',
      source: 'odgovorna_organizacija',
      ttoken: 'pp:registar.odgovorna_organizacija',
      type: 'text',
      filter: true,
      readonly: true,
    },
    {
      title: 'poveznica',
      source: 'poveznica',
      ttoken: 'pp:registar.poveznica',
      type: 'text',
      filter: true,
      readonly: true,
    },
    {
      title: 'izvan_snage',
      source: 'izvan_snage',
      ttoken: 'pp:registar.izvan_snage',
      type: 'boolean',
      items: {
        labels: ['common.no', 'common.yes'],
        values: [false, true],
      },
      filter: true,
      readonly: true,
    },
    {
      title: 'nova_generacija',
      source: 'nova_generacija',
      ttoken: 'pp:registar.nova_generacija',
      type: 'boolean',
      items: {
        labels: ['common.no', 'common.yes'],
        values: [false, true],
      },
      filter: true,
      readonly: true,
    },
    coreFields.created_by,
    coreFields.created_on,
    coreFields.modified_by,
    coreFields.modified_on,
  ],
};

export default RegistarProstornihPlanova;
